const OnChangePageLimit = function(limit) {
  this.collection.limit = limit
  this.collection.page = 1
  this.collection.setCurrentPage(0)
  this.collection.fetchData()
}
export default OnChangePageLimit